import { Link } from "@/components/common/Link";
export default function MediaAndCommunityPresence() {
  return <section data-section-id="3268" id="mediaandcommunitypresence" className="bg-[hsl(30,10%,95%)] py-12 text-foreground md:py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mb-10 max-w-3xl md:mb-14 lg:mb-18">
          <p className="mb-6 font-mono text-xs uppercase tracking-[0.25em] text-primary">
            — Media &amp; Community Presence
          </p>

          <h2 className="mb-6 font-serif text-4xl font-light leading-[1.05] tracking-tight text-foreground md:text-5xl lg:text-[3rem]">
            Media &amp; Community Presence
          </h2>

          <p className="text-lg text-muted-foreground">
            Over decades in South Florida, Morrie I. Levine&apos;s work has
            extended beyond private client matters to broadcast appearances,
            professional publications, public-facing legal commentary, and a
            longstanding local professional presence.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {}
          <article className="group flex h-full flex-col rounded-lg border border-border bg-card p-5 shadow-sm">
            <div className="relative mb-5 overflow-hidden rounded-lg">
              <Link to="https://youtu.be/RmVQDwZtR3I" newTab className="block aspect-video w-full cursor-pointer overflow-hidden bg-muted" aria-label="Watch Morrie I. Levine's Jaguar commercial appearance">
                <img src="https://probable-basilisk.10web.cloud/wp-content/uploads/2026/07/Jaguar-Commercial-2.png" data-wvc-srcset="https://probable-basilisk.10web.cloud/wp-content/uploads/2026/07/Jaguar-Commercial-2.png" data-wvc-sizes="https://probable-basilisk.10web.cloud/wp-content/uploads/2026/07/Jaguar-Commercial-2.png" alt="Morrie I. Levine featured in a Jaguar commercial" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.02]" loading="lazy" decoding="async" />
              </Link>
            </div>

            <p className="mb-4 font-mono text-[0.7rem] uppercase tracking-[0.25em] text-primary">
              Featured Appearance
            </p>

            <h3 className="mb-3 font-serif text-3xl font-light leading-[1.05] tracking-tight text-foreground">
              Jaguar Commercial Appearance
            </h3>

            <p className="font-sans text-base leading-relaxed text-muted-foreground">
              Selected commercial media appearance featuring Morrie I. Levine.
            </p>

            <div className="mt-3 font-sans text-sm leading-relaxed text-foreground">
              <p className="font-semibold">ジャガーコマーシャル出演</p>
              <p className="text-muted-foreground">モーリー・I・レヴィン弁護士が出演したジャガーのコマーシャル映像です。</p>
            </div>

            <Link to="https://youtu.be/RmVQDwZtR3I" newTab className="mt-auto inline-flex pt-6 font-sans text-sm font-medium text-foreground no-underline transition-opacity hover:opacity-70">
              Watch the Appearance →
            </Link>
          </article>

          {}
          <article className="group flex h-full flex-col rounded-lg border border-border bg-card p-5 shadow-sm">
            <div className="relative mb-5 overflow-hidden rounded-lg">
              <Link to="https://youtu.be/-EmVu-zcV_s" newTab className="block aspect-video w-full cursor-pointer overflow-hidden bg-muted" aria-label="Watch Morrie I. Levine's Channel 7 News interview">
                <img src="https://probable-basilisk.10web.cloud/wp-content/uploads/2026/07/Channel-7-News-2.png" data-wvc-srcset="https://probable-basilisk.10web.cloud/wp-content/uploads/2026/07/Channel-7-News-2.png" data-wvc-sizes="https://probable-basilisk.10web.cloud/wp-content/uploads/2026/07/Channel-7-News-2.png" alt="Morrie I. Levine appearing in a Channel 7 News interview" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.02]" loading="lazy" decoding="async" />
              </Link>
            </div>

            <p className="mb-4 font-mono text-[0.7rem] uppercase tracking-[0.25em] text-primary">
              Broadcast Appearance
            </p>

            <h3 className="mb-3 font-serif text-3xl font-light leading-[1.05] tracking-tight text-foreground">
              Channel 7 News Interview
            </h3>

            <p className="font-sans text-base leading-relaxed text-muted-foreground">
              A regional news appearance featuring Morrie I. Levine in
              connection with a South Florida legal matter.
            </p>

            <div className="mt-3 font-sans text-sm leading-relaxed text-foreground">
              <p className="font-semibold">テレビ出演</p>
              <p className="text-muted-foreground">モーリー・I・レヴィン弁護士がChannel 7 Newsのインタビューに出演した映像です。</p>
            </div>

            <Link to="https://youtu.be/-EmVu-zcV_s" newTab className="mt-auto inline-flex pt-6 font-sans text-sm font-medium text-foreground no-underline transition-opacity hover:opacity-70">
              Watch the Interview →
            </Link>
          </article>


          {}
        <article className="group flex h-full flex-col rounded-lg border border-border bg-card p-5 shadow-sm md:col-span-2 lg:col-span-1">
  <div className="relative mb-5 overflow-hidden rounded-lg">
    <Link to="https://www.floridabar.org/the-florida-bar-journal/a-legal-roller-coaster-the-corporate-transparency-act/" newTab className="block cursor-pointer" aria-label="View A Legal Roller Coaster: The Corporate Transparency Act on The Florida Bar website">
      <div className="relative aspect-video w-full overflow-hidden bg-white">
        <img src="https://probable-basilisk.10web.cloud/wp-content/uploads/2026/07/22.png" data-wvc-srcset="https://probable-basilisk.10web.cloud/wp-content/uploads/2026/07/22.png" data-wvc-sizes="https://probable-basilisk.10web.cloud/wp-content/uploads/2026/07/22.png" alt="First page of A Legal Roller Coaster: The Corporate Transparency Act" className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-[1.02]" loading="lazy" decoding="async" />

        <div className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#10233f] via-[#10233f]/90 to-transparent px-5 pb-4 pt-14">
          <p className="font-mono text-[0.6rem] uppercase tracking-[0.22em] text-white/75">
            The Florida Bar Journal
          </p>

          <p className="mt-1 font-serif text-lg leading-tight text-white">
            Published Legal Analysis
          </p>
        </div>
      </div>
    </Link>
  </div>

  <p className="mb-4 font-mono text-[0.7rem] uppercase tracking-[0.25em] text-primary">
    Published Legal Analysis
  </p>

          <h3 className="mb-3 font-serif text-[1.65rem] font-light leading-[1.08] tracking-tight text-foreground">
  <Link to="https://www.floridabar.org/the-florida-bar-journal/a-legal-roller-coaster-the-corporate-transparency-act/" newTab className="text-inherit no-underline transition-opacity hover:opacity-70">
      A Legal Roller Coaster: The Corporate Transparency Act
    </Link>
  </h3>

  <p className="mb-3 font-sans text-sm font-medium leading-relaxed text-foreground">
    Co-authored by Peter J. Guala and Morrie I. Levine
  </p>

  <div className="mt-2 font-sans text-sm leading-relaxed text-foreground">
    <p className="font-semibold">The Florida Bar Journal掲載</p>
    <p className="text-muted-foreground">Corporate Transparency Actに関する共著論考がThe Florida Bar Journalに掲載されました。</p>
  </div>

  <p className="mt-4 font-sans text-xs leading-relaxed text-muted-foreground">The official Florida Bar page may be unavailable in certain regions. A PDF copy is available below.</p>

  <div className="mt-auto flex flex-wrap gap-x-5 gap-y-3 pt-6">
    <Link to="https://www.floridabar.org/the-florida-bar-journal/a-legal-roller-coaster-the-corporate-transparency-act/" newTab className="inline-flex font-sans text-sm font-medium text-foreground no-underline transition-opacity hover:opacity-70">
      View on The Florida Bar →
    </Link>

    <Link to="https://probable-basilisk.10web.cloud/wp-content/uploads/2026/07/Florida-Bar-Journal-Full-Article.pdf" newTab className="inline-flex font-sans text-sm text-muted-foreground underline underline-offset-4 transition-opacity hover:opacity-70">
      Read PDF
    </Link>
  </div>
        </article>
                  </div>

      <div className="mt-12 text-center md:mt-16">
  <p className="mb-2 font-serif text-base font-medium text-muted-foreground">
    日本語プロフィール
  </p>

  <Link to="https://morrielevine.com/モーリー-i-レヴィン弁護士-フロリダ州-弁護士/" className="font-sans text-sm font-medium text-primary hover:underline">
    モーリー・I・レヴィン弁護士について日本語で詳しく見る →
  </Link>
</div>
      </div>
    </section>;
}